import { UiAgentOfficeDeal } from 'screens/AgentOfficePages/common/sections/deals/types';
import { DealAffiliationType } from 'utils/entities';

export const countDealsTotal = (data: UiAgentOfficeDeal[]): number => {
  if (!Array.isArray(data) || !data.length) return 0;

  return data.reduce((acc, item) => {
    if (item.side === DealAffiliationType.Both) return acc + 2;
    if (item.side === DealAffiliationType.Buyer || item.side === DealAffiliationType.Seller) return acc + 1;
    return acc;
  }, 0);
};
